import React from 'react';
import FieldValTypography from '../../common/FieldValTypography';
// reusable source model fields component.
function SourceViewerDialogFields({ name, createdDate, size }) {
	return (
		<div>
			<FieldValTypography field="Source" val={name} />
			<FieldValTypography field="Date Created" val={createdDate} />
			<FieldValTypography field="Size" val={size} />
		</div>
	);
}

export default SourceViewerDialogFields;
